module.exports = __webpack_public_path__ + "img/qr-code-android.f95688e5.png";